import { gql } from '@at/sauron-platform-graphql';
export const ConversationGql = gql `
    mutation ConversationMutation {
        conversation {
            initiateChat {
                jwtToken
            }
        }
    }
`;
